import React from "react";
import { FixedIcon } from "../../../atoms/icons/fixed";
import { addTrailingZeroes } from "../../../util/addTrailingZeroes";
import { Indicator } from "./Indicator";
import { dollarFormatter } from "../../../util/dollarFormatter";
import { ViewLoanIcon } from "../../../atoms/icons/view-loan";
import { handleAddRemove } from "../../../util/compare_utils";
import CheckIcon from "@mui/icons-material/Check";
import { AddPlusIcon } from "../../../atoms/icons/add-plus";

export const ListRow = ({
  quote,
  isComparedIds,
  setComparedId,
  setDetails,
  rateProgress = 0,
  aprProgress = 0,
  monthlyProgress = 0,
  closingProgress = 0,
}) => {
  const { apr, rate, monthlyPayment, closingCosts, id } = quote;

  const handleView = () => {
    setDetails(id);
  };

  return (
    <div
      className={`list-row ${
        isComparedIds.includes(id) ? "compared-list" : ""
      }`}
    >
      <div className="list-cell first-list-cell">
        <FixedIcon fill="white" width="30px" height="30px" />
        {addTrailingZeroes(rate)}%
        <Indicator progress={rateProgress} />
      </div>
      <div className="list-cell">
        <div className="align-left">
          {dollarFormatter(Math.round(monthlyPayment))}
        </div>
        <Indicator progress={monthlyProgress} />
      </div>
      <div className="list-cell">
        <div className="align-left">
          {dollarFormatter(Math.round(closingCosts))}
        </div>
        <Indicator progress={closingProgress} />
      </div>
      <div className="list-cell">
        {addTrailingZeroes(apr)}%
        <Indicator progress={aprProgress} />
      </div>
      <div className="list-cell centered">
        <ViewLoanIcon fill="white" width="30px" onClick={handleView} />
      </div>
      <div className="list-cell centered -list-cell">
        {isComparedIds.includes(id) ? (
          <div
            onClick={() =>
              handleAddRemove({ isComparedIds, setComparedId, id })
            }
            className="added-button"
          >
            <div className="checked-icon-wrapper">
              <CheckIcon sx={{ color: "white" }} fontSize="small" />
            </div>
            <div>Added</div>
          </div>
        ) : (
          <div
            onClick={() =>
              handleAddRemove({ isComparedIds, setComparedId, id })
            }
            className="add-button"
          >
            <AddPlusIcon fill="white" />
            <div className="transparent">Add</div>
          </div>
        )}
      </div>
    </div>
  );
};
